import { render, staticRenderFns } from "./addPosition.vue?vue&type=template&id=2871f3fe&scoped=true"
import script from "./addPosition.vue?vue&type=script&lang=js"
export * from "./addPosition.vue?vue&type=script&lang=js"
import style0 from "./addPosition.vue?vue&type=style&index=0&id=2871f3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871f3fe",
  null
  
)

export default component.exports